import React, { useEffect, useState, useRef, lazy  } from 'react'
import styled from 'styled-components'
import theme from '../theme.json'


export default function LegalNotices({ }) {

    const MdxContent = lazy(() => {
        return import(`../content/legalNotices.mdx`).catch((err) => {
            return import(`../content/default.mdx`)
        })
    })

    return (
        <Page>
            wdrht
            <MdxContent />
        </Page>

    )
}


const Page = styled.div`
    flex: 1;
    margin-top: 8vh;
    min-height: 92vh;
    padding: 5vh 20vw 5vh 20vw;
    overflow: auto;
    display: flex;
    flex-direction: column;
    gap: 20px;
    @media (max-width: 1100px) {
        padding: 5vh 12vw 5vh 12vw;
    };
`